<app-modal-dialog
    [show]="showModal"
    size="full"
    position="top"
    (closed)="closedCreateNote()"
    #modal
>
    <div class="modal-header" modal-header>
        <h1>Crea Proceso Productivo</h1>
        <h1 style="left: 0" class="i-hover">
            <i class="fa fa-xmark" (click)="closeModal(modal)"></i>
        </h1>
    </div>

    <div class="modal-body" modal-body>
        <div class="row mb-4">
            <div class="col-sm-12 form-group mb-4">
                <label for="name" class="form-label">Nombre del Proceso</label>
                <input
                type="text"
                [(ngModel)]="name"
                name="name"
                id="name"
                class="form-control"
                placeholder="Ej: Proceso de Producción Materia X"
                />
            </div>
        </div>

        <div class="row mb-4">
            <div class="col-sm-4 form-group mb-4" >
                <label for="productType" class="form-label">Tipo</label>
                <div class="input-group">
                    <select name="productType" [(ngModel)]="productType" id="productType" class="form-select">
                        <option value="0" disabled>Selecciona un Tipo</option>
                        <option value="INPUT">Entrada</option>
                        <option value="OUTPUT">Salida</option>
                    </select>
                </div>
            </div>

            <div class="col-sm-8 form-group mb-4">
                <label for="product-order" class="form-label">Producto</label>
                <div class="input-group">
                    <app-input-autocomplete
                        [allBorderRadius]="true"
                        [inputs]="inputs.product"
                        [placeholder]="'Ingresa un producto'"
                        [filterElements]="filterProducts"
                        [typeElements]="'product-order'"
                        (inputMethod)="writeProduct($event.event)"
                        (changeStatus)="checkProduct($event.filterElement)"
                        (getTitle)="
                            $event.filterElement.title =
                                $event.filterElement.code +
                                ' - ' +
                                $event.filterElement.name
                        "
                    ></app-input-autocomplete>
                </div>
            </div>
        </div>

        <div class="row mb-4">
            <svg id="svg-container" #svgContainer></svg>
            <!-- Entradas -->
            <div class="col">
                <h5>Productos de entrada</h5>
                <div class="table-responsive ti-border-left">
                    <table class="table" id="table-in">
                        <thead>
                            <tr class="tr-middle border">
                                <th></th>
                                <th class="text-left">Producto</th>
                                <th class="text-right">Cantidad</th>
                                <th class="td-center"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr 
                            *ngFor=" let item of productsProcessIn; let i = index"
                            [attr.data-id]="item.product.id"
                            [class.selected]="selectedInId == item.product.id"
                            class="border"
                            >
                                <td>
                                    <div class="d-flex flex-col">
                                        <span class="text-md font-bold">{{ item.product.name }}</span>
                                        <span class="text-sm">{{ item.product.code }}</span>
                                    </div>
                                </td>
                                <td >
                                    <input type="number" class="form-control form-control-sm w-300" [(ngModel)]="item.quantity">
                                </td>
                                <td>
                                    <span class="a-hover text-danger ml-2" (click)="deleteProduct(i, item.type)"><i class="fa fa-trash"></i></span>
                                </td>
                                <td (click)="toggleIn(item.product.id)" class="border">
                                    <i [ngClass]="selectedInId == item.product.id ? 'fa-solid fa-circle' : 'fa-regular fa-circle'"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Salidas -->
            <div class="col">
                <h5>Productos de salida</h5>
                <div class="table-responsive">
                    <table class="table" id="table-out">
                        <thead>
                            <tr class="tr-middle border">
                                <th class="text-left">Producto</th>
                                <th class="text-center">%</th>
                                <th class="td-center"></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr 
                            *ngFor=" let item of productsProcessOut; let i = index"
                            [attr.data-id]="item.product.id"
                            [class.selected]="isSelectedOut(item.product.id)"
                            class="border"
                            >
                                <td (click)="toggleOut(item.product.id)" class="border">
                                    <i [ngClass]="isSelectedOut(item.product.id) ? 'fa-solid fa-circle' : 'fa-regular fa-circle'"></i>
                                </td>
                                <td >
                                    <div class="d-flex flex-col">
                                        <span class="text-md font-bold">{{ item.product.name }}</span>
                                        <span class="text-sm">{{ item.product.code }}</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="row">
                                        <input type="number" class="form-control form-control-sm w-200" [(ngModel)]="item.percentage">
                                    </div>
                                </td>
                                <td>
                                    <span class="a-hover text-danger ml-2"  (click)="deleteProduct(i, item.type)"><i class="fa fa-trash"></i></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="d-flex flex-row justify-end">
                <button class="btn btn-success"
                        [disabled]="getDisabledSave()"
                        (click)="saveAssociation(modal)">
                    <i class="fa" [ngClass]="buttonAssociate.icon"></i>
                    Guardar
                    <!-- {{ buttonAssociate.text }} -->
                </button>
            </div>
        </div>

    </div>
</app-modal-dialog>
